var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['booking_notifications'])?_c('b-button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.emailInvoices.apply(null, arguments)}}},[_vm._v(" E-mail invoices ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }